module.exports = (__webpack_require__("UAjq"))("7oro");